//--------------------------------
// IMPORT STYLE and IMAGES
import './styles/index.scss';
const imagesContext = require.context('./images', true, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
imagesContext.keys().forEach(imagesContext);

const themeImagesContext = require.context('./images', true, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
themeImagesContext.keys().forEach(themeImagesContext);

// import global types
import './types/global.types';

window.$ = $;

//--------------------------------
// IMPORT GLOBAL FILES
import "bootstrap";
import naja from 'naja';
import { ComponentFactory, ComponentsType } from './components/ComponentFactory';
import ExtensionRegistrar from './extensions/ExtensionRegistrar';

//--------------------------------
// IMPORT LIBRARIES
import 'webpack-jquery-ui';
import 'webpack-jquery-ui/css';
import 'hammerjs';
import 'jquery-hammerjs';
import 'jquery-mousewheel';
import 'what-input';

import './lib/jquery.nms.extensions';
import './lib/imgViewer2'; // jquery plugin


//--------------------------------
// CONFIGURE SENTRY
import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://8002ac1c69104a5da0aa79ee317b071d@o1168082.ingest.us.sentry.io/6265793",
        integrations: [new Sentry.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.0,

    });
}

//--------------------------------
// IMPORT & REGISTER COMPONENTS
import ActivationStep from "./components/ActivationStep";
import Autocomplete from "./components/Autocomplete";
import CheckAll from "./components/CheckAll";
import DisableElements from "./components/DisableElements";
import ClientSelection from "./components/ClientSection";
import CommentForm from "./components/CommentForm";
import ContentTranslation from "./components/ContentTranslation";
import contentTranslationClient from "./components/ContentTranslation/ContentTranslationClient";
import DashboardWidgets from "./components/DashboardWidgets";
import Diary from "./components/Diary/js/Diary";
import EntryTags from "./components/EntryTags";
import FileInput from "./components/FileInput";
import FlashOverlayModal from "./components/FlashOverlayModal";
import GeneralInfoForm from "./components/GeneralInfoForm";
import GridActionOnChange from "./components/GridActionOnChange";
import ImageRating, {ImageRatingView} from "./components/ImageRating";
import InterviewForm from "./components/InterviewForm";
import InterviewThread from "./components/InterviewThread";
import EmailEditor from "./components/EmailEditor";
import FilterContainer from "./components/FilterContainer";
import FilterProjectUsersDropdown from "./components/FilterProjectUsersDropdown";
import FilterSelectDropdown from "./components/FilterSelectDropdown";
import FilterTagsDropdown from "./components/FilterTagsDropdown";
import PollForm from "./components/PollForm/js/PollForm";
import VideoCallForm from "./components/VideoCallForm/js/VideoCallForm";
import VideoCallTimer from "./components/VideoCallTimer/js/VideoCallTimer";
import PremiumBenefitsCard from "./components/PremiumBenefitsCard";
import PrivateMessages from "./components/PrivateMessages/js/PrivateMessages";
import { ProjectFormAttributes, ProjectFormQuestionary, ProjectFormTouchpoints } from "./components/ProjectForm";
import RespondentSelection from "./components/RespondentSelection";
import DiaryRewardsForm from "./components/DiaryRewardsForm";
import RewardsExchangeRate from "./components/RewardsExchangeRate";
import UsersImport from "./components/UsersImport";
import RegistrationForm from "./components/RegistrationForm";
import ToastMessage from "./components/ToastMessage";
import TopicForm from "./components/TopicForm";
import UploadAvatarModal from './components/UploadAvatarModal';
import Recaptcha from './components/Recaptcha';
import LanguageSwitch from './components/LanguageSwitch';
import LanguageDetection from './components/LanguageDetection';
import { OpenAIMinutes } from './components/OpenAI';
import SearchInput from './components/SearchInput';
import StarsRating from './components/StarsRating';
import BulkEmailForm from './components/BulkEmailForm';
import DiscussionCompletionConditions from './components/DiscussionCompletionConditions';
import AudioPlayer from './components/AudioPlayer/js/AudioPlayer';
import VideoPlayer from './components/VideoPlayer/js/VideoPlayer';
import DesignResearch from "./components/DesignResearch";
import ChatbotModeration from "./components/ChatbotModeration";
import TopicsTagAssignment from "./components/TopicsTagAssignment";
import ToPayOutGridWarnings from "./components/ToPayOutGridWarnings";

import "./components/UnfinishedActivityCounter";

const components: ComponentsType = {
    ActivationStep: ActivationStep,
    AnalyzeDiscussions: AnalyzeDiscussions,
    AudioPlayer: AudioPlayer,
    Autocomplete: Autocomplete,
    BulkEmailForm: BulkEmailForm,
    Chatbot: Chatbot,
    ChatbotModeration: ChatbotModeration,
    CheckAll: CheckAll,
    ClientSelection: ClientSelection,
    CommentForm: CommentForm,
    ContentTranslation: ContentTranslation,
    DashboardWidgets: DashboardWidgets,
    DesignResearch: DesignResearch,
    Diary: Diary,
    DiaryRewardsForm: DiaryRewardsForm,
    DisableElements: DisableElements,
    DiscussionFormConfirmation: DiscussionFormConfirmation,
    DiscussionCompletionConditions: DiscussionCompletionConditions,
    EmailEditor: EmailEditor,
    EntryTags: EntryTags,
    FileInput: FileInput,
    FilterProjectUsersDropdown: FilterProjectUsersDropdown,
    FilterSelectDropdown: FilterSelectDropdown,
    FilterTagsDropdown: FilterTagsDropdown,
    FiltersContainer: FilterContainer,
    FlashOverlayModal: FlashOverlayModal,
    GeneralInfoForm: GeneralInfoForm,
    GridActionOnChange: GridActionOnChange,
    ImageRating: ImageRating,
    ImageRatingView: ImageRatingView,
    InterviewForm: InterviewForm,
    InterviewThread: InterviewThread,
    LanguageSwitch: LanguageSwitch,
    LanguageDetection: LanguageDetection,
    OpenAIMinutes: OpenAIMinutes,
    PhoneInput: PhoneInput,
    PollForm: PollForm,
    PremiumBenefitsCard: PremiumBenefitsCard,
    PrivateMessages: PrivateMessages,
    ProjectFormAttributes: ProjectFormAttributes,
    ProjectFormQuestionary: ProjectFormQuestionary,
    ProjectFormTouchpoints: ProjectFormTouchpoints,
    Recaptcha: Recaptcha,
    RegistrationForm: RegistrationForm,
    RespondentSelection: RespondentSelection,
    RewardsExchangeRate: RewardsExchangeRate,
    SearchInput: SearchInput,
    StarsRating: StarsRating,
    ToastMessage: ToastMessage,
    ToPayOutGridWarnings: ToPayOutGridWarnings,
    TopicForm: TopicForm,
    TopicsTagAssignment: TopicsTagAssignment,
    UploadAvatarModal: UploadAvatarModal,
    UsersImport: UsersImport,
    VideoCallForm: VideoCallForm,
    VideoCallTimer: VideoCallTimer,
    VideoPlayer: VideoPlayer,
}

//--------------------------------
// IMPORT & REGISTER EXTENSIONS
ExtensionRegistrar.addExtension(contentTranslationClient);
ExtensionRegistrar.addExtension(new ComponentFactory(components));

import NetteFormsExtension from "./extensions/NetteFormsExtension";
ExtensionRegistrar.addExtension(new NetteFormsExtension());

import {DatagridExtension, DatagridConfirm, DatagridSpinnersExtension, DatagridInstantUrlRefresh } from './extensions/Datagrid';
ExtensionRegistrar.addExtension(new DatagridExtension());
ExtensionRegistrar.addExtension(new DatagridConfirm());
ExtensionRegistrar.addExtension(new DatagridSpinnersExtension());
ExtensionRegistrar.addExtension(new DatagridInstantUrlRefresh());

import RevealMainContentExtension from "./extensions/RevealMainContentExtension";
ExtensionRegistrar.addExtension(new RevealMainContentExtension());

import AnimateHeightExtension from "./extensions/AnimateHeightExtension";
ExtensionRegistrar.addExtension(new AnimateHeightExtension());

import ButtonAsLinkExtension from "./extensions/ButtonAsLinkExtension";
ExtensionRegistrar.addExtension(new ButtonAsLinkExtension());

import ActionAfterChangeExtension from "./extensions/ActionAfterChangeExtension";
ExtensionRegistrar.addExtension(new ActionAfterChangeExtension());

import ClipboardExtension from "./extensions/ClipboardExtension";
ExtensionRegistrar.addExtension(new ClipboardExtension());

import CloseModalsExtension from "./extensions/CloseModalsExtension";
ExtensionRegistrar.addExtension(new CloseModalsExtension());

import OpenModalsExtension from "./extensions/OpenModalsExtension";
ExtensionRegistrar.addExtension(new OpenModalsExtension());

import OffcanvasAutoShowExtension from "./extensions/OffcanvasAutoShowExtension";
ExtensionRegistrar.addExtension(new OffcanvasAutoShowExtension());

import OffcanvasExtension from "./extensions/OffcanvasExtension";
ExtensionRegistrar.addExtension(new OffcanvasExtension());

import ModalInOffcanvasExtension from "./extensions/ModalInOffcanvasExtension";
ExtensionRegistrar.addExtension(new ModalInOffcanvasExtension());

import ConfirmExtension from "./extensions/ConfirmExtension";
ExtensionRegistrar.addExtension(new ConfirmExtension());

import DependSelectBoxExtension from "./extensions/DependentSelectBox/js/DependSelectBoxExtension";
ExtensionRegistrar.addExtension(new DependSelectBoxExtension());

import FileUploadExtension from "./extensions/FileUploadExtension";
ExtensionRegistrar.addExtension(new FileUploadExtension());

import HideOnEmptyContentExtension from "./extensions/HideOnEmptyContentExtension";
ExtensionRegistrar.addExtension(new HideOnEmptyContentExtension());

import InactiveLinksExtension from "./extensions/InactiveLinksExtension";
ExtensionRegistrar.addExtension(new InactiveLinksExtension());

import InputRangeOutputExtension from "./extensions/InputRangeOutputExtension";
ExtensionRegistrar.addExtension(new InputRangeOutputExtension());

import IosFileUploadFixExtension from "./extensions/IosFileUploadFixExtension";
ExtensionRegistrar.addExtension(new IosFileUploadFixExtension());

import LinkifyExtension from "./extensions/LinkifyExtension";
ExtensionRegistrar.addExtension(new LinkifyExtension());

import LightboxExtension from "./extensions/Lightbox";
ExtensionRegistrar.addExtension(new LightboxExtension());

import ModalExtension from "./extensions/ModalExtension";
ExtensionRegistrar.addExtension(new ModalExtension());

import OnClickRedirectExtension from "./extensions/OnClickRedirectExtension";
ExtensionRegistrar.addExtension(new OnClickRedirectExtension());

import PopoversExtension from "./extensions/PopoversExtension";
ExtensionRegistrar.addExtension(new PopoversExtension());

import PreventEnterSubmitExtension from "./extensions/PreventEnterSubmitExtension";
ExtensionRegistrar.addExtension(new PreventEnterSubmitExtension());

import ProcessHiddenFormsExtension from "./extensions/ProcessHiddenFormsExtension";
ExtensionRegistrar.addExtension(new ProcessHiddenFormsExtension());

import RevealDiaryExtension from "./extensions/RevealDiaryExtension";
ExtensionRegistrar.addExtension(new RevealDiaryExtension());

import RevealDiscussionExtension from "./extensions/RevealDiscussionExtension";
ExtensionRegistrar.addExtension(new RevealDiscussionExtension());

import RevealLinkExtension from "./extensions/RevealLinkExtension";
ExtensionRegistrar.addExtension(new RevealLinkExtension());

import SelectizeExtension from "./extensions/SelectizeExtension";
ExtensionRegistrar.addExtension(new SelectizeExtension());

import ShowLoaderExtension from "./extensions/ShowLoaderExtension";
ExtensionRegistrar.addExtension(new ShowLoaderExtension());

import StopEventPropagationExtension from "./extensions/StopEventPropagationExtension";
ExtensionRegistrar.addExtension(new StopEventPropagationExtension());

import AjaxSpinnersExtension from "./extensions/AjaxSpinnersExtension";
ExtensionRegistrar.addExtension(new AjaxSpinnersExtension());

import SubmitFormOnEnterKeyExtension from "./extensions/SubmitFormOnEnterKeyExtension";
ExtensionRegistrar.addExtension(new SubmitFormOnEnterKeyExtension());

import SubmittedFormsExtension from "./extensions/SubmittedFormsExtension";
ExtensionRegistrar.addExtension(new SubmittedFormsExtension());

import TabsExtension from "./extensions/TabsExtension";
ExtensionRegistrar.addExtension(new TabsExtension());

import TooltipExtension from "./extensions/TooltipExtension";
ExtensionRegistrar.addExtension(new TooltipExtension());

import ScrollToElementExtension from "./extensions/ScrollToElementExtension";
ExtensionRegistrar.addExtension(new ScrollToElementExtension());

import ScrollToAnchorExtension from "./extensions/ScrollToAnchorExtension";
ExtensionRegistrar.addExtension(new ScrollToAnchorExtension());

import UserActivitiesExtension from "./extensions/UserActivitiesExtension";
ExtensionRegistrar.addExtension(new UserActivitiesExtension());

import WarnOnUnsavedChangesExtension from "./extensions/WarnOnUnsavedChangesExtension";
ExtensionRegistrar.addExtension(new WarnOnUnsavedChangesExtension());

import YoutubeVideosExtension from "./extensions/YoutubeVideosExtension";
ExtensionRegistrar.addExtension(new YoutubeVideosExtension());

import { DatePicker, DateTimePicker } from "./extensions/FlatPickr";
ExtensionRegistrar.addExtension(new DatePicker());
ExtensionRegistrar.addExtension(new DateTimePicker());

import Dashboard from "./extensions/Dashboard";
ExtensionRegistrar.addExtension(new Dashboard());

import InfiniteScrollExtension from "./extensions/InfiniteScrollExtension";
ExtensionRegistrar.addExtension(new InfiniteScrollExtension());

import UserFreeAccountChecker from './extensions/UserFreeAccountChecker';
ExtensionRegistrar.addExtension(new UserFreeAccountChecker());

import ClickTargetExtension from './extensions/ClickTargetExtension';
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
ExtensionRegistrar.addExtension(new ClickTargetExtension());

import ConfettiExtension from './extensions/ConfettiExtension';
ExtensionRegistrar.addExtension(new ConfettiExtension());

import SnippetIntervalRefreshExtension from "./extensions/SnippetIntervalRefreshExtension";
ExtensionRegistrar.addExtension(new SnippetIntervalRefreshExtension());

import ExcelExportExtension from './extensions/Excel';
import PhoneInput from "./components/PhoneInput";
import DiscussionFormConfirmation from "./components/DiscussionFormConfirmation";
ExtensionRegistrar.addExtension(new ExcelExportExtension());

import ConfirmInputChangeExtension from "./extensions/ConfirmInputChangeExtension";
ExtensionRegistrar.addExtension(new ConfirmInputChangeExtension());

import PreventDoubleSubmitExtension from "./extensions/PreventDoubleSubmitExtension";
import PreventDoubleClickExtension from "./extensions/PreventDoubleClickExtension";
import Chatbot from "./components/Chatbot";
import AnalyzeDiscussions from "./components/AnalyzeDiscussions";
ExtensionRegistrar.addExtension(new PreventDoubleSubmitExtension());
ExtensionRegistrar.addExtension(new PreventDoubleClickExtension());

import DateRangeExtension from "./extensions/DateRangePicker";
ExtensionRegistrar.addExtension(new DateRangeExtension());

import KeepFileInputValueExtension from "./extensions/KeepFileInputValueExtension";
ExtensionRegistrar.addExtension(new KeepFileInputValueExtension());

import EmojiConverterExtension from "./extensions/EmojiConverterExtension";
ExtensionRegistrar.addExtension(new EmojiConverterExtension());

import MainNavDropdownExtension from "./extensions/MainNavDropdownExtension";
ExtensionRegistrar.addExtension(new MainNavDropdownExtension());

ExtensionRegistrar.register();

//--------------------------------
// INIT PAGE FUNCTION

document.addEventListener('DOMContentLoaded', () => {
    naja.initialize({
        history: false,
        historyUiCache: false,
    });

});
